import moment from 'moment';

import axios from 'utils/axios';

// Goal periods are resolved on the server (Eastern): the client names a period,
// it never computes the window. `period` is one of day | week | month | month-to-yesterday.
export async function getGoalProgressForUser(userId, period) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/user/${userId}/productivity-goal-day/progress`, {
            params: { period }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// Custom ranges are the one case where the client picks the window: the user chose
// arbitrary dates, sent as browser-local UTC instants, half-open [fromTS, toTS).
// No goal is attached to a custom range.
export async function getCustomRangeCareStatsForLoggedInUser(fromTS, toTS) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity/care-stats/custom-time-range`, {
            params: {
                fromTS,
                toTS
            }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getMonthlyInteractionsForLoggedInUser() {
    // the current calendar month in browser-local time, half-open [fromTS, toTS)
    const fromTS = moment().startOf('month').valueOf();
    const toTS = moment().startOf('month').add(1, 'month').valueOf();
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity/care-stats/monthly-interactions`, {
            params: {
                fromTS,
                toTS
            }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
